import {FC} from 'react';
import { Button } from '@material-ui/core';
import { useFormikContext } from 'formik';
import { ButtonSubmitProps } from '../../../interfaces';

const ButtonWrapper:FC<ButtonSubmitProps> = ({
  children,
  disabled,
  style,
  ...otherProps
}) => {
  const { submitForm, } = useFormikContext();

  const handleSubmit = () => {
    submitForm();

  }

  const configButton:any = {
    variant: 'contained',
    color: 'secondary',
    size: 'medium',
    onClick: handleSubmit
  }

  return (
    <Button 
      style={style}
      disabled={disabled}
      className="MuiButton-medium"
      {...otherProps}
      {...configButton}
    >
      {children}
    </Button>
  );
};

export default ButtonWrapper;
